// extracted by mini-css-extract-plugin
export default {"desktop":"1199","desktopBig":"1599","tablet":"699","tabletLandscape":"899","wiggle":"_0aYKV0G1--style_wiggle__+1GD9","shimmer":"_0aYKV0G1--style_shimmer__46tMA"};